import { TImageType, getEmptyImage } from '../../../Helper/Image';
import cn from 'classnames';
import React, { useMemo, useState } from 'react';
import KickImage from 'Reuseables/KickImage';

export interface IImageProps
  extends React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  type?: TImageType;
  cdnWidth?: number;
}

const Image: React.FC<IImageProps> = ({
  src,
  alt,
  style,
  type = 'default',
  cdnWidth,
  className,
  ...props
}) => {
  if (!type) {
    type = 'default';
  }

  const imageStyle = useMemo(() => {
    if (style) {
      return style;
    }

    return {
      width: '100%',
    };
  }, [style]);

  const imageSrc = useMemo(() => {
    return src || getEmptyImage(type);
  }, [src]);

  const onErrorImage = (event) => {
    event.target.src = getEmptyImage(type);
  };

  return (
    <KickImage
      onError={(ev) => onErrorImage(ev)}
      src={imageSrc}
      alt={alt || `${type}-image`}
      style={imageStyle}
      className={cn(className)}
      {...(cdnWidth && { cdnWidth })}
      {...props}
    />
  );
};

export default Image;
